// Actions
export const setTeams = ({ commit }, payload) => {
  commit('SET_TEAMS', payload)
}
export const addTeams = ({ commit }, payload) => {
  commit('ADD_TEAMS', payload)
}
export const setTeamsLoading = ({ commit }, payload) => {
  commit('SET_TEAMS_LOADING', payload)
}

export const setRoas = ({ commit }, payload) => {
  commit('SET_ROAS', payload)
}
export const addRoas = ({ commit }, payload) => {
  commit('ADD_ROAS', payload)
}
export const setRoasLoading = ({ commit }, payload) => {
  commit('SET_ROAS_LOADING', payload)
}
export const setFamilyGroup = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP', payload)
}
export const addFamilyGroup = ({ commit }, payload) => {
  commit('ADD_FAMILY_GROUP', payload)
}
export const setFamilyGroupLoading = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_LOADING', payload)
}

export const setBenchmarks = ({ commit }, payload) => {
  commit('SET_BENCHMARKS', payload)
}
export const addBenchmarks = ({ commit }, payload) => {
  commit('ADD_BENCHMARKS', payload)
}
export const setBenchmarksLoading = ({ commit }, payload) => {
  commit('SET_BENCHMARKS_LOADING', payload)
}

export const setRoutesSettings = ({ commit }, payload) => {
  commit('SET_ROUTES_SETTINGS', payload)
}

export const removeRoutesSettings = ({ commit }, payload) => {
  commit('REMOVE_ROUTES_SETTINGS', payload)
}

export const clearRoutesSettings = ({ commit }, payload) => {
  commit('CLEAR_ROUTES_SETTINGS', payload)
}

export const setOfficeParametrization = ({ commit }, payload) => {
  commit('SET_OFFICE_PARAMETRIZATION', payload)
}
export const addOfficeParametrization = ({ commit }, payload) => {
  commit('ADD_OFFICE_PARAMETRIZATION', payload)
}
export const setOfficeParametrizationLoading = ({ commit }, payload) => {
  commit('SET_OFFICE_PARAMETRIZATION_LOADING', payload)
}

export const setRubrics = ({ commit }, payload) => {
  commit('SET_RUBRICS', payload)
}
export const addRubrics = ({ commit }, payload) => {
  commit('ADD_RUBRICS', payload)
}
export const setRubricsLoading = ({ commit }, payload) => {
  commit('SET_RUBRICS_LOADING', payload)
}
export const setDepartments = ({ commit }, payload) => {
  commit('SET_DEPARTMENTS', payload)
}
export const addDepartments = ({ commit }, payload) => {
  commit('ADD_DEPARTMENTS', payload)
}
export const setDepartmentsLoading = ({ commit }, payload) => {
  commit('SET_DEPARTMENTS_LOADING', payload)
}

export const setPermissionsAssessor = ({ commit }, payload) => {
  commit('SET_PERMISSIONS_ASSESSOR', payload)
}
export const addPermissionsAssessor = ({ commit }, payload) => {
  commit('ADD_PERMISSIONS_ASSESSOR', payload)
}
export const setPermissionsAssessorLoading = ({ commit }, payload) => {
  commit('SET_PERMISSIONS_ASSESSOR_LOADING', payload)
}
export const setRepositoryFiles = ({ commit }, payload) => {
  commit('SET_REPOSITORY_FILES', payload)
}
export const addRepositoryFiles = ({ commit }, payload) => {
  commit('ADD_REPOSITORY_FILES', payload)
}
export const setRepositoryFilesLoading = ({ commit }, payload) => {
  commit('SET_REPOSITORY_FILES_LOADING', payload)
}

export const setAssetAllocationTypes = ({ commit }, payload) => {
  commit('SET_ASSET_ALLOCATION_TYPES', payload)
}
export const addAssetAllocationTypes = ({ commit }, payload) => {
  commit('ADD_ASSET_ALLOCATION_TYPES', payload)
}
export const setAssetAllocationTypesLoading = ({ commit }, payload) => {
  commit('SET_ASSET_ALLOCATION_TYPES_LOADING', payload)
}

export const setDreTempFilters = ({ commit }, payload) => {
  commit('SET_DRE_TEMP_FILTERS', payload)
}

export const setSuperRankingClusters = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_CLUSTERS', payload)
}
export const setSuperRankingClustersLoading = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_CLUSTERS_LOADING', payload)
}

export const setSuperRankingCycles = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_CYCLES', payload)
}
export const setSuperRankingCyclesLoading = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_CYCLES_LOADING', payload)
}

export const setSuperRankingIndicators = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_INDICATORS', payload)
}
export const setSuperRankingIndicatorsLoading = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_INDICATORS_LOADING', payload)
}

export const setSuperRankingFunctions = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_FUNCTIONS', payload)
}
export const setSuperRankingFunctionsLoading = ({ commit }, payload) => {
  commit('SET_SUPER_RANKING_FUNCTIONS_LOADING', payload)
}

export const setOpenFinanceConexoes = ({ commit }, payload) => {
  commit('SET_OPEN_FINANCE_CONEXOES', payload)
}
